export default {
  data() {
    return {
      scrollbarVisible: true,
    };
  },
  methods: {
    paperScroll() {
      this.scrollbarVisible = false;
      if (this.constructor.hoverTimer) clearTimeout(this.constructor.hoverTimer);
      this.constructor.hoverTimer = setTimeout(() => {
        this.scrollbarVisible = true;
      }, 400);
    },
  },
};
